import React, { useState, useEffect } from 'react';
import { Button, Input, Checkbox, Modal, Table as AntTable } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import * as Papa from 'papaparse';

const CSVFile = ({ dataSource, initialColumns, visible, onClose }) => {
  const [columns, setColumns] = useState(initialColumns.map(col => ({ ...col, enabled: true })));
  const [fileName, setFileName] = useState('export.csv');
  const [previewData, setPreviewData] = useState([]);

  useEffect(() => {
    // Update preview data whenever columns change
    const previewColumns = columns.filter(col => col.enabled).map(col => col.dataIndex);
    const renamedColumns = columns.filter(col => col.enabled).reduce((acc, col) => ({ ...acc, [col.dataIndex]: col.title }), {});

    const newData = dataSource.map(row => {
      let newRow = {};
      previewColumns.forEach(col => {
        newRow[renamedColumns[col]] = row[col];
      });
      return newRow;
    });

    setPreviewData(newData);
  }, [columns, dataSource]);
  const handleExport = () => {
    const filteredData = dataSource.map(row => {
      const newRow = {};
      columns.forEach(({ dataIndex, title, enabled }) => {
        if (enabled) newRow[title] = row[dataIndex];
      });
      return newRow;
    });

    const csv = Papa.unparse(filteredData, {
      columns: columns.filter(col => col.enabled).map(col => col.title),
    });
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName; // Ensure fileName ends with .csv
    link.click();
    onClose(); // Close the modal after initiating the download
  };

  return (
    <Modal
      title="Customize CSV Export"
      visible={visible}
      onCancel={onClose}
      width={720}
      footer={[
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleExport}>
          Export
        </Button>,
      ]}
    >
      <Input
        placeholder="File Name"
        defaultValue="export.csv"
        onChange={e => setFileName(e.target.value.endsWith('.csv') ? e.target.value : e.target.value + '.csv')}
        style={{ marginBottom: 20 }}
      />
      <AntTable dataSource={columns} pagination={false} rowKey="dataIndex">
        <AntTable.Column title="Column" dataIndex="title" key="title" render={(text, record, index) => (
          <Input defaultValue={text} onChange={e => {
            const newColumns = [...columns];
            newColumns[index].title = e.target.value;
            setColumns(newColumns);
          }} />
        )} />
        <AntTable.Column title="Export" dataIndex="enabled" key="enabled" render={(text, record, index) => (
          <Checkbox checked={record.enabled} onChange={e => {
            const newColumns = [...columns];
            newColumns[index].enabled = e.target.checked;
            setColumns(newColumns);
          }} />
        )} />
      </AntTable>
      <h3 style={{ marginTop: 20 }}>Preview</h3>
      <AntTable dataSource={previewData} pagination={false} rowKey="id">
        {columns.filter(col => col.enabled).map(col => (
          <AntTable.Column key={col.dataIndex} title={col.title} dataIndex={col.title} />
        ))}
      </AntTable>
    </Modal>
  );
};

export default CSVFile;
